import { login } from "features";
import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../../assets/css/onboard.css";
import StorageService from "utils/StorageServices/StorageServices";
import { CommonInput } from "components";
import { errorSchema, utils } from "helper";
import toast from "react-hot-toast";
import { Images } from "constants";
import { BasicExample } from "components/common/CommonModal/CommonModal";
import "./Login.css";
import { UserContext } from "context";

const Login = () => {
  const emailRef = useRef();
  const passRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, error, data } = useSelector((state) => state.auth);
  const [formError, setFormError] = useState("");
  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const {setUserType} = useContext(UserContext)

  useEffect(() => {
    if (emailRef.current) {
      emailRef.current.focus();
    }
  }, []);

  const handleOnChange = async (name, value) => {
    setForm((prevForm) => {
      const updatedForm = {
        ...prevForm,
        [name]: value,
      };

      if (formError) {
        utils
          .checkFormError(
            {
              ...updatedForm,
            },
            errorSchema.loginSchema
          )
          .then((validationResult) => {
            if (validationResult === true) {
              setFormError("");
            } else {
              setFormError(validationResult);
            }
          });
      }

      return updatedForm;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationResult = await utils?.checkFormError(
      form,
      errorSchema.loginSchema
    );
    if (validationResult === true) {
      try {
        const res = await dispatch(login(form));
        if (res.payload?.status === 200) {
          StorageService.setToken(res?.payload?.results?.access);
          const userType = res?.payload?.results?.user_type
          setUserType(res?.payload?.results?.user_type)
          StorageService.setUserType(res?.payload?.results?.user_type)
          navigate(userType==3?"/booking/room":userType==4?"store/buyer":"/dashboard");
        } else {
          toast.error(res.payload?.message);
        }
      } catch (error) {
        throw error;
      }
    } else {
      setFormError(validationResult);
    }
  };

  const handleKey = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (nextInputRef) {
        nextInputRef.current.focus();
      } else {
        handleSubmit(e);
      }
    } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
      e.preventDefault();
    }
  };

  return (
    // <div className="_midOb_bx">
    //   <div className="_midOd_head">
    //       {/* <h3>Welcome To Dharti Dhora Ri </h3> */}

    //       <img className="_logoOn_board " src={Images.LOGO} alt="" />
    //     </div>
    //   <div className="_innrMid_bx">

    //       <div className="_subFrm_fx">
    //       <div className="singleDiv">
    //           <CommonInput
    //             type="email"
    //             label="Email"
    //             placeholder="Enter Email"
    //             name="email"
    //             value={form?.email}
    //             onChange={({ target: { name, value } }) => {
    //               handleOnChange(name,value);
    //             }}
    //             focus={!!formError?.email}
    //             error={formError.email}
    //             ref={emailRef}
    //             onKeyDown={(e) => handleKey(e, passRef)}

    //           />
    //         </div>
    //         <div className="singleDiv">
    //           <CommonInput
    //             type="password"
    //             label="Password"
    //             placeholder="Enter Password"
    //             name="password"
    //             value={form?.password}
    //             onChange={({ target: { name, value } }) => {
    //               handleOnChange(name,value);
    //             }}
    //             focus={!!formError?.password}
    //             error={formError.password}
    //             ref={passRef}
    //             onKeyDown={(e) => handleKey(e, null)}

    //           />
    //         </div>

    //         <button
    //           type="submit"
    //           disabled={loading}
    //           className="anime-btn _submitOn_board"
    //           onClick={(e)=>handleSubmit(e)}
    //         >
    //           {loading ? <BasicExample/> : "Login"}{" "}
    //         </button>
    //       </div>

    //   </div>

    //   {/* <div className="_midBx_foot">
    //     <p>
    //       By clicking on Verify you agree to our <a href="">Terms</a> and{" "}
    //       <a href="">Privacy Policy</a>
    //     </p>
    //     <p>© 2024 . All rights reserved.</p>
    //   </div> */}
    // </div>
    <div className="login-container">
      <div className="login-box">
        <h2>Login</h2>
        <form onSubmit={handleSubmit} >
          <div className="input-group">
            <label>Email</label>
            <input
              type="email"
              className="lognInput"
              placeholder="Enter your email"
              value={form.email}
              ref={emailRef}
              onChange={(e) => handleOnChange("email", e.target.value)}
              onKeyDown={(e) => handleKey(e, passRef)}
            />
            {formError.email && (
              <span className="error">{formError.email}</span>
            )}
          </div>
          <div className="input-group">
            <label>Password</label>
            <input
              type="password"
              placeholder="Enter your password"
              value={form.password}
              ref={passRef}
              onChange={(e) => handleOnChange("password", e.target.value)}
              onKeyDown={(e) => handleKey(e, null)}
            />
            {formError.password && (
              <span className="error">{formError.password}</span>
            )}
          </div>
          {/* <div className="input-group"></div> */}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Logging in..." : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
